import styled from 'styled-components';
import { Layout } from '../Layouts.types';

export const StyledThreeInRowLayout = styled.div`
    width: 100%;
    height: auto;
    display: flex;
    max-width: 1248px;
    flex-flow: row wrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding-top: 20px;

    .bundle {
        width: calc(calc(100% / 3) - 6px);
    }
    .bundle-price {
        max-width: 85%;
        margin-top: 4em;
        max-height: 2em;
    }
` as any;

const ThreeInRowLayout = ({ children }: Layout) => {
    return <StyledThreeInRowLayout>{children}</StyledThreeInRowLayout>;
};

export default ThreeInRowLayout;
